import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Image,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  Space,
  Spin,
  Switch,
  Tag,
  Tooltip,
} from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import deleteIcon from "../../assets/images/delete-icon.svg";
import editIcon from "../../assets/images/edit-icon.svg";
import leftArrow from "../../assets/images/LeftArrow.svg";
import "./configuration.scss";
import { inputFieldCharLimit } from "../../config/index";
import { truncate } from "../../utils/helper";
import UserIcon from "../../assets/images/user-icon.svg";
import uuid from "react-uuid";
import FooterDocumentSettings from "./FooterDocumentSettings";
import BulkUploadBlock from "./BulkUploadBlock";
import PaymentPlanConfiguration from "./PaymentPlanConfiguration";

const parseIntegerInput = (value) => {
  if (value === undefined || value === null) {
    return "";
  }
  return String(value).replace(/\D/g, "");
};

const blockNonIntegerKey = (event) => {
  if (event.ctrlKey || event.metaKey) {
    return;
  }
  const { key } = event;
  if (key.length === 1 && !/\d/.test(key)) {
    event.preventDefault();
  }
};

const integerInputProps = {
  parser: parseIntegerInput,
  onKeyDown: blockNonIntegerKey,
  precision: 0,
};

export default function Configurations() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const [form3] = Form.useForm();
  const [form4] = Form.useForm();
  const [form5] = Form.useForm();
  const [form6] = Form.useForm();
  const inputRef = useRef(null);
  const [image, setImage] = useState();
  const [media, setmedia] = useState({});


  const partnerId = sessionStorage.getItem("partnerId");
  const partnerName = sessionStorage.getItem("partnerName");
  const subDomainName = sessionStorage.getItem("subDomainName");
  const [disableSaveTime, setDisabledSaveTime] = useState(true);

  const [sectors, setSectors] = useState([]);
  const [subsectors, setSubSectors] = useState([]);
  const [customName, setCustomName] = useState("");
  const [customNameSubSector, setCustomNameSubSector] = useState("");
  const [selectedSector, setSelectedSector] = useState(null);
  const [selectedSubSector, setSelectedSubSector] = useState(null);
  const [sectorSelectedFlag, setSectorSelectedFlag] = useState(false);

  const [saveDisabled, setSaveDisabled] = useState(true);
  const [newOrganisationType, setNewOrganisationType] = useState([]);
  const [newPartnerType, setNewPartnerType] = useState([]);
  const [editID, setEditID] = useState();
  const [partnerEditID, setPartnerEditID] = useState();
  const [organisationTypes, setOrganisationTypes] = useState([]);
  const [organisationTypesAddDisable, setOrganisationTypesAddDisable] =
    useState(true);
  const [partnerTypes, setPartnerTypes] = useState([]);
  const [partnerTypesAddDisable, setPartnerTypesAddDisable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadingPartnerType, setLoadingPartnerType] = useState(false);
  const [restoreTime, setRestoreTime] = useState("");
  const freeTrialFormInitialState = {
    freeTrialPeriod: null,
    extendedTrialOrganizationLimit: null,
    extendedTrialPeriod: null,
    extendedPlanForFreeTrial: undefined,
    freePlanAlwaysPlan: undefined,
    isFreePlanAlways: null,
  };

  const normalizeFreePlanAlways = (value) => {
    if (value === true) return true;
    if (value === false) return false;
    return null;
  };

  const mapTrialDataForForm = (data = {}) => {
    const isFreePlanAlways = normalizeFreePlanAlways(data.isFreePlanAlways);
    const { planForFreeTrial, freePlanAlwaysPlan, ...rest } = data;
    return {
      ...rest,
      isFreePlanAlways,
      extendedPlanForFreeTrial: planForFreeTrial ?? undefined,
      freePlanAlwaysPlan:
        isFreePlanAlways === true ? freePlanAlwaysPlan ?? undefined : undefined,
    };
  };

  const [trialConfig, setTrialConfig] = useState({
    ...freeTrialFormInitialState,
  });
  const [savedTrialConfig, setSavedTrialConfig] = useState(null);

  const [disableFreeTrialSave, setDisableFreeTrialSave] = useState(true);
  const launchOrgLimit = Form.useWatch("extendedTrialOrganizationLimit", form4);
  const isFreePlanAlwaysSelected = Form.useWatch("isFreePlanAlways", form4);
  const isLaunchOrgZero = launchOrgLimit === 0;
  const isFreeForeverPlan =
    trialConfig.isFreePlanAlways === true ||
    isFreePlanAlwaysSelected === true;
  const requiresExtendedFreeTrialFields =
    !isFreeForeverPlan &&
    launchOrgLimit !== null &&
    launchOrgLimit !== undefined &&
    launchOrgLimit > 0;
  const areTrialDetailFieldsDisabled = isLaunchOrgZero || isFreeForeverPlan;
  const [getFile, setFile] = useState();
  const [partnerDetailsData, setPartnerDetailsData] = useState({});

  const freeTrialDayFieldRules = (required) => [
    {
      required,
      message: "Please input the number of days.",
    },
    {
      type: "number",
      message: "Please input a valid number.",
    },
    {
      validator: (_, value) => {
        if (!required && (value === null || value === undefined || value === "")) {
          return Promise.resolve();
        }
        if (value < 0) {
          return Promise.reject(
            new Error("Negative values are not allowed.")
          );
        }
        return Promise.resolve();
      },
    },
  ];


  // -----------
  const [loadingSalesType, setLoadingSalesType] = useState(false);
  const [salesTypes, setSalesTypes] = useState([]);
  const [salesTypesAddDisable, setSalesTypesAddDisable] = useState(true);
  const [newSalesType, setNewSalesType] = useState([]);
  const [salesEditID, setSalesEditID] = useState(null);


  const validateNumber = (rule, value) => {
    if (isNaN(value)) {
      return Promise.reject("Please enter a valid number.");
    }
    if (value < 1) {
      return Promise.reject("Number must be greater than 0.");
    }
    if (value > 90) {
      toast.error("Number must not be more than 90 days.");
      return Promise.reject("Number must not be more than 90 days.");
    }
    return Promise.resolve();
  };

  const getDeletionThresholdDays = useCallback(async () => {
    try {
      const { data } = await getRequest(
        userServiceApi.getDeletionThresholdDays(partnerId)
      );
      if (data) {
        form.setFieldValue("deletionThresholdDays", data);
        setRestoreTime(data);
      }
    } catch (error) {
      toast.error(error);
    }
  }, [form, partnerId]);

  const fetchFreeTrialPeriod = useCallback(async () => {
    try {
      const { data } = await getRequest(
        userServiceApi.fetchFreeTrialPeriod(partnerId)
      );
      let trialData = mapTrialDataForForm(data);
      trialData = {
        ...trialData,
        planForFreeTrial: null,
      };
      if (trialData.extendedTrialOrganizationLimit === 0) {
        trialData = {
          ...trialData,
          extendedPlanForFreeTrial: null,
          extendedTrialPeriod: null,
          freeTrialPeriod: null,
        };
      }
      form4.setFieldsValue(trialData);
      setTrialConfig(trialData);
      setSavedTrialConfig(trialData);
    } catch (error) {
      toast.error(error);
    }
  }, [form4, partnerId]);

  const clearFreeTrialValidation = () => {
    form4.setFields(
      [
        "freePlanAlwaysPlan",
        "extendedPlanForFreeTrial",
        "extendedTrialOrganizationLimit",
        "extendedTrialPeriod",
        "freeTrialPeriod",
        "isFreePlanAlways",
      ].map((name) => ({ name, errors: [] }))
    );
  };

  const handleFreeTrialCancel = () => {
    if (savedTrialConfig) {
      setTrialConfig(savedTrialConfig);
      form4.setFieldsValue(mapTrialDataForForm(savedTrialConfig));
      clearFreeTrialValidation();
    }
    setDisableFreeTrialSave(true);
  };

  const handleFreeTrialClear = () => {
    setTrialConfig(freeTrialFormInitialState);
    form4.setFieldsValue(freeTrialFormInitialState);
    clearFreeTrialValidation();
    setDisableFreeTrialSave(true);
  };

  const getPartnerDetailsData = useCallback(async () => {
    try {
      const response = await getRequest(
        userServiceApi.getPartnerDetails(subDomainName)
      );
      if (response && response?.data) {
        setPartnerDetailsData(response?.data);
      }
    } catch (error) {
      toast.error(error.error);
    }
  }, [subDomainName]);

  useEffect(() => {
    if (partnerId) {
      getDeletionThresholdDays();
      fetchFreeTrialPeriod();
      getPartnerDetailsData();
    }
  }, [partnerId, getDeletionThresholdDays, fetchFreeTrialPeriod, getPartnerDetailsData]);

  const onFinishRestoreConfig = async () => {
    try {
      if (restoreTime) {
        const response = await putRequest(
          userServiceApi.updateRestoreTime(partnerId, restoreTime)
        );
        if (response) {
          getDeletionThresholdDays();
          toast.success(
            `Time to restore organisation in ${partnerName} updated`
          );
          setRestoreTime("");
          form.resetFields();
          setDisabledSaveTime(true);
        }
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const trialFieldOrNull = (value) =>
    value === undefined || value === "" ? null : value;

  const onFinishSubscriptionTrial = async (values) => {
    try {
      const limit = trialConfig.extendedTrialOrganizationLimit;
      const isZeroLaunch = limit === 0;
      const isFreeForever = trialConfig.isFreePlanAlways === true;
      const isFreePlanAlwaysPayload =
        trialConfig.isFreePlanAlways === null ||
        trialConfig.isFreePlanAlways === undefined
          ? null
          : trialConfig.isFreePlanAlways;
      const isValid = isFreeForever
        ? trialConfig.isFreePlanAlways === true &&
          trialConfig.freePlanAlwaysPlan != null &&
          String(trialConfig.freePlanAlwaysPlan).trim() !== ""
        : isZeroLaunch
          ? limit !== null && limit !== undefined
          : [
            "extendedPlanForFreeTrial",
            "extendedTrialOrganizationLimit",
            "extendedTrialPeriod",
            "freeTrialPeriod",
          ].every((key) => {
            const value = trialConfig[key];
            return value != null && String(value).trim() !== "";
          });
      if (isValid) {
        const freePlanAlwaysPlanPayload =
          trialConfig.isFreePlanAlways === true
            ? trialConfig.freePlanAlwaysPlan ?? null
            : null;
        const payload = isFreeForever
          ? {
            isFreePlanAlways: true,
            planForFreeTrial: null,
            freePlanAlwaysPlan: freePlanAlwaysPlanPayload,
            extendedTrialOrganizationLimit: null,
            extendedTrialPeriod: null,
            freeTrialPeriod: null,
          }
          : isZeroLaunch
            ? {
              isFreePlanAlways: isFreePlanAlwaysPayload,
              extendedTrialOrganizationLimit: 0,
              planForFreeTrial: null,
              freePlanAlwaysPlan: freePlanAlwaysPlanPayload,
              extendedTrialPeriod: null,
              freeTrialPeriod: null,
            }
            : {
              freeTrialPeriod: trialConfig.freeTrialPeriod,
              extendedTrialOrganizationLimit:
                trialConfig.extendedTrialOrganizationLimit,
              extendedTrialPeriod: trialConfig.extendedTrialPeriod,
              planForFreeTrial: trialConfig.extendedPlanForFreeTrial ?? null,
              freePlanAlwaysPlan: freePlanAlwaysPlanPayload,
              isFreePlanAlways: isFreePlanAlwaysPayload,
            };
        const response = await putRequest(
          userServiceApi.updateSubscriptionTrialPeriod(partnerId),
          payload
        );
        if (response) {
          fetchFreeTrialPeriod();
          toast.success("Trial period added successfully");
          setTrialConfig((prev) => ({
            ...prev,
            freeTrialPeriod: null,
            extendedTrialOrganizationLimit: null,
            extendedTrialPeriod: null,
          }));
          form4.resetFields();
          setDisableFreeTrialSave(true);
        }
      } else {
        toast.error("Please fill all the fields before saving");
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const handleSectorSelectChange = (sectorSelectedValue) => {
    setSubSectors([]);
    setSelectedSubSector(null);
    setSectorSelectedFlag(true);
    setSelectedSector(sectorSelectedValue);
    setSaveDisabled(false);
  };

  const handleSubSectorSelectChange = (value) => {
    setSelectedSubSector(value);
  };

  const handleDeleteSubSectorItem = async (item) => {
    try {
      if (selectedSubSector === item?.value) {
        setSelectedSubSector(null);
        form3.setFieldValue("subSector", null);
      }

      if (item?.status === "NEW") {
        const filteredData = subsectors?.filter((dt) => dt?.id !== item?.value);
        setSubSectors(filteredData);
        toast.success("Deleted sub-category item successfully");
      } else {
        const response = await deleteRequest(
          userServiceApi.deleteSubsector(item?.value)
        );
        if (response) {
          toast.success("Deleted sub-category item successfully");
          getAllSubSectors();
        }
      }
    } catch (error) {
      toast.error(error);
    }
  }

  const closeSectorModal = () => {
    setSelectedSector(null);
    setCustomName("");
    setSelectedSubSector(null);
    setCustomNameSubSector("");
    setSaveDisabled(true);
    setSectorSelectedFlag(false);
    form3.resetFields();
  };

  const postsectorSubsector = async () => {
    try {
      if (!isValidUUID(selectedSector) && subsectors) {
        const formattedData = {
          partnerId: partnerId,
          name: selectedSector,
          subSectors: subsectors?.map(({ status, ...rest }) => rest),
        };
        const response = await postRequest(
          userServiceApi.postsectorSubsector(),
          formattedData
        );
        if (response) {
          toast.success("Category and Sub-category added");
          getAllSectors();
          setTimeout(() => {
            closeSectorModal();
          }, 500)
        }
      } else {
        const formattedData = subsectors?.filter((sector) => sector?.status === "NEW")?.map(({ status, ...rest }) => rest);
        const response = await postRequest(
          userServiceApi.updatesectorSubsector(selectedSector, partnerId),
          formattedData
        );
        if (response) {
          toast.success("Category and Sub-category updated");
          getAllSectors();
          setTimeout(() => {
            closeSectorModal();
          }, 500)
          // closeSectorModal();
        }
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const onNameChange = (e) => setCustomName(e.target.value);
  const onNameChangeSubSector = (e) => setCustomNameSubSector(e.target.value);

  // const addItem = () => {
  //   if (customName && !sectors.includes(customName)) {
  //     setSectors((prevSectors) => [...prevSectors, { name: customName }]);
  //     setCustomName("");
  //     setSaveDisabled(false);
  //   }
  // };

  const addItem = () => {
    if (!customName) return;
    const newCategory = { id: customName, name: customName, status: "NEW" };
    setSectors((prev) => [...prev, newCategory]);
    setCustomName("");
  };

  // const addItemSubSector = () => {
  //   if (customNameSubSector && !subsectors.includes(customNameSubSector)) {
  //     setSubSectors((prevSectors) => [
  //       ...prevSectors,
  //       { name: customNameSubSector },
  //     ]);
  //     setCustomNameSubSector("");
  //     setSaveDisabled(false);
  //   }
  // };

  const addItemSubSector = () => {
    if (!customNameSubSector) return;
    const newSubCategory = { id: Date.now(), name: customNameSubSector, status: "NEW" };
    setSubSectors((prev) => [...prev, newSubCategory]);
    setCustomNameSubSector("");
  };

  const deleteSector = async (data) => {
    try {
      if (selectedSector === data?.value) {
        setSelectedSector(null);
        setSelectedSubSector(null);
        form3.setFieldValue("sector", null);
        form3.setFieldValue("subSector", null);
      }
      if (data?.status === "NEW") {
        const filteredSectorData = sectors?.filter((dt) => dt?.id !== data?.value);
        setSectors(filteredSectorData);
        setSubSectors([]);
        toast.success("Deleted category item successfully");
        closeSectorModal();
      } else {
        const response = await deleteRequest(
          userServiceApi.deleteSector(data?.value)
        );
        if (response) {
          toast.success("Deleted category item successfully");
          getAllSectors();
          closeSectorModal();
        }
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const deleteAllSectors = async () => {
    try {
      const response = await deleteRequest(
        userServiceApi.deleteAllSectors(partnerId)
      );
      if (response) {
        toast.success("Deleted all categories and sub-categories successfully");
        getAllSectors();
        closeSectorModal();
      }
    } catch (error) {
      toast.error(error);
    }
  }

  const deleteAllSubSectors = async () => {
    try {
      const response = await deleteRequest(
        userServiceApi.deleteAllSubSectors(selectedSector)
      );
      if (response) {
        toast.success(response || "Deleted all sub-categories successfully");
        getAllSubSectors();
        closeSectorModal();
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error(error);
    }
  }

  const getAllSectors = useCallback(async () => {
    try {
      const response = await getRequest(
        userServiceApi.getAllSectors(partnerId)
      );
      if (response) {
        setSectors(response?.data);
      }
    } catch (error) {
      toast.error(error);
    }
  }, [partnerId]);

  const getAllSubSectors = useCallback(async () => {
    try {
      const response = await getRequest(
        userServiceApi.getAllSubSectors(selectedSector)
      );
      if (response) {
        setSubSectors(response.data);
      }
    } catch (error) {
      toast.error(error);
    }
  }, [selectedSector]);

  useEffect(() => {
    if (partnerId) {
      getAllSectors();
    }
  }, [partnerId, getAllSectors]);

  const isValidUUID = (value) => {
    const uuidRegex =
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    return uuidRegex.test(value);
  };

  useEffect(() => {
    if (isValidUUID(selectedSector)) {
      getAllSubSectors();
    }
  }, [selectedSector, getAllSubSectors]);

  const handleAdd = ({ type }) => {
    if (type && type.trim().length) {
      setNewOrganisationType([...newOrganisationType, type]);
      inputRef.current.value = "";
      inputRef.current.focus();
      form1.resetFields();
      setOrganisationTypesAddDisable(true);
    }
  };

  const handlePartnerAdd = ({ type }) => {
    if (type && type.trim().length) {
      setNewPartnerType([...newPartnerType, type]);
      inputRef.current.value = "";
      inputRef.current.focus();
      form2.resetFields();
      setPartnerTypesAddDisable(true);
    }
  };

  const handlecancelSave = () => {
    setNewOrganisationType([]);
    form1.resetFields();
    setOrganisationTypesAddDisable(true);
  };

  const handlePartnercancelSave = () => {
    setNewPartnerType([]);
    form2.resetFields();
    setPartnerTypesAddDisable(true);
  };

  const handleRemove = (tagToRemove) => {
    setNewOrganisationType(
      newOrganisationType?.filter((tag) => tag !== tagToRemove)
    );
  };

  const handlePartnerRemove = (tagToRemove) => {
    setNewPartnerType(newPartnerType?.filter((tag) => tag !== tagToRemove));
  };

  const handleSave = async () => {
    const moddedArray = newOrganisationType?.map((item) => {
      return {
        displayName: item,
        type: "ORGANIZATION_TYPE",
      };
    });
    try {
      const response = await postRequest(
        userServiceApi.postAddOrganisationOrPartnerType(partnerId),
        moddedArray
      );
      if (response) {
        toast.success("New Organisation types added");
        setNewOrganisationType([]);
        getAllOrganisationTypes();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handlePartnerSave = async () => {
    const moddedArray = newPartnerType?.map((item) => {
      return {
        displayName: item,
        type: "PARTNER_TYPE",
      };
    });
    try {
      const response = await postRequest(
        userServiceApi.postPartnerType(partnerId),
        moddedArray
      );
      if (response) {
        toast.success("New Partner types added");
        setNewPartnerType([]);
        getAllPartnerTypes();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getAllOrganisationTypes = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getRequest(
        userServiceApi.getAllOrganizationTypes(partnerId)
      );
      if (response) {
        setOrganisationTypes(response.data);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  }, [partnerId]);

  const getAllPartnerTypes = useCallback(async () => {
    try {
      setLoadingPartnerType(true);
      const response = await getRequest(
        userServiceApi.getAllPartnerTypes(partnerId)
      );
      if (response) {
        setPartnerTypes(response.data);
        setLoadingPartnerType(false);
      }
    } catch (error) {
      console.error(error);
      setLoadingPartnerType(false);
    }
  }, [partnerId]);

  const getAllSalesTypes = useCallback(async () => {
    try {
      setLoadingSalesType(true);
      const response = await getRequest(
        userServiceApi.getAllSalesTypes(partnerId)
      );
      if (response) {
        setSalesTypes(response?.data);
        setLoadingSalesType(false);
      }
    } catch (error) {
      console.error(error);
      setLoadingSalesType(false);
    }
  }, [partnerId]);

  useEffect(() => {
    getAllOrganisationTypes();
    getAllPartnerTypes();
    getAllSalesTypes();
  }, [getAllOrganisationTypes, getAllPartnerTypes, getAllSalesTypes]);

  const handleDelete = async (type) => {
    try {
      const response = await deleteRequest(
        userServiceApi.deleteOrganisationType(type.id)
      );
      if (response) {
        getAllOrganisationTypes();
        toast.success(`${type.displayName} deleted successfully`);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handlePartnerDelete = async (type) => {
    try {
      const response = await deleteRequest(
        userServiceApi.deletePartnerType(type.id)
      );
      if (response) {
        getAllPartnerTypes();
        toast.success(`${type.type} deleted successfully`);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleEdit = async (value) => {
    let editObj = {
      id: editID,
      displayName: value.type,
      type: "ORGANIZATION_TYPE",
    };

    try {
      const response = await putRequest(
        userServiceApi.putEditOrganisationOrPartnerType(partnerId),
        editObj
      );
      if (response) {
        setEditID();
        toast.success("Organisation type edited successfully");
        setOrganisationTypes(response);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handlePartnerEdit = async (value) => {
    let editObj = {
      id: partnerEditID,
      displayName: value.type,
      type: "PARTNER_TYPE",
    };

    try {
      const response = await putRequest(
        userServiceApi.putEditOrganisationOrPartnerType(partnerId),
        editObj
      );
      if (response) {
        setPartnerEditID();
        toast.success("Partner type edited successfully");
        setPartnerTypes(response);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleChecker = async (checked, type) => {
    let editObj = {
      ...type,
      toggle: checked,
    };

    try {
      const response = await putRequest(
        userServiceApi.putEditOrganisationOrPartnerType(partnerId),
        editObj
      );
      if (response) {
        setEditID();
        setOrganisationTypes(response);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handlePartnerChecker = async (checked, type) => {
    let editObj = {
      ...type,
      toggle: checked,
    };

    try {
      const response = await putRequest(
        userServiceApi.putEditOrganisationOrPartnerType(partnerId),
        editObj
      );
      if (response) {
        setPartnerEditID();
        setPartnerTypes(response);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const downloadExcelTemplate = async (templateEnum, downloadingFilename) => {
    try {
      const authToken = sessionStorage.getItem("token");

      const downloadUrl = userServiceApi.downloadExcelTemplate(templateEnum);
      const response = await axios.get(downloadUrl, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        responseType: "blob",
      });

      if (response) {
        // const fileName = templateEnum === "ACCURATE_SECTOR_SUB_SECTOR" ? "Accurate_Template.xlsx"  :   "Template.xlsx";
        const fileName = downloadingFilename || "Template.xlsx";

        const blob = new Blob([response.data]);
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    } catch (error) {
      toast.error("Error downloading file");
    }
  };
  const checkFile = (file) => {
    const isExcelFile =
      file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.type === "application/vnd.ms-excel";

    if (!isExcelFile) {
      toast.error("You can only upload Excel files (XLSX or XLS)!");
    }
    return isExcelFile;
  };

  const uploadFile = async (templateEnum, formData) => {
    try {
      const url =
        templateEnum === "PARTNER_DIRECTORIES"
          ? userServiceApi.uploadExcelDirectoryTemplate(templateEnum, partnerId)
          : userServiceApi.uploadExcelTemplate(templateEnum, partnerId);

      const res = await postRequest(url, formData);

      if (res) {
        toast.success("File uploaded successfully");
        getAllSectors();
      }
    } catch (error) {
      console.error(error);
      toast.error(error.error);
    }
  };

  const uploadPropsBase = {
    accept: ".xls, .xlsx",
    beforeUpload: checkFile,
    maxCount: 1,
    multiple: false,
    showUploadList: false,
  };

  const getUploadProps = (templateEnum) => ({
    ...uploadPropsBase,
    customRequest: ({ file }) => {
      const formData = new FormData();
      const blob = new Blob([file], {
        type: "multipart/form-data",
      });
      formData.append("file", blob, file?.name);
      uploadFile(templateEnum, formData);
    },
  });


  const changeHandler = (event) => {
    const MAX_SIZE = 2.5 * 1024 * 1024; // 2MB
    if (event?.target?.files[0]) {
      const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
      var file = event?.target?.files[0]?.name;
      var FT = event?.target?.files[0]?.type;

      if (file && !allowedTypes?.includes(FT)) {
        toast.error("Only image files are allowed(JPG, PNG, JPEG)");
        return;
      } else if (event?.target?.files && event?.target?.files[0]?.size > MAX_SIZE) {
        toast.error("File should not exceed 2.5MB");
      } else {
        setImage(event?.target?.files[0]);
        let unique_ID = uuid();
        var fileArray = file?.split(".");
        var fileExt = fileArray[fileArray?.length - 1];

        var fileName = file?.split(".")?.slice(0, -1)?.join(".");
        var fileType = FT?.substr(0, FT?.lastIndexOf("/"));
        const items = {
          mediaType: fileType === "image" ? "IMAGE" : null,
          mediaProperty: {
            id: unique_ID,
            name: fileName,
            extension: fileExt,
          },
        };
        setmedia({ ...items });
        var image = event.target?.files[0];
        var blob = image.slice(0, image.size);
        const newFile = new File([blob], `${unique_ID}_${fileName}.${fileExt}`, {
          type: `${image.type}`,
        });
        setFile(newFile);
        const fields = form.getFieldsValue(true);
        form.resetFields();
        form.setFieldsValue({ ...fields });
      }
    }
  };

  const onFinishPoweredByLogo = async () => {
    try {
      if (getFile) {
        const payload = {
          media: media,
        }
        const json = JSON?.stringify(payload);
        const blob = new Blob([json], {
          type: "application/json",
        });
        var formData = new FormData();
        formData.append("media", blob);
        formData.append("file", getFile);
        const headers = {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        };
        const response = await postRequest(
          userServiceApi.uploadPoweredByLogo(partnerId),
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              ...headers,
            },
          }
        );

        if (response) {
          toast.success("Powered by logo uploaded successfully");
          setmedia({});
          form.resetFields();
        }
      } else {
        toast.error("Please select a file to upload");
      }
    } catch (error) {
      toast.error("Error uploading file");
    }
  };


  const handleSalesAdd = ({ type }) => {
    if (type && type?.trim()?.length) {
      setNewSalesType([...newSalesType, type]);
      inputRef.current.value = "";
      inputRef.current.focus();
      form6.resetFields();
      setSalesTypesAddDisable(true);
    }
  };

  const handleSalesRemove = (tagToRemove) => {
    setNewSalesType(newPartnerType?.filter((tag) => tag !== tagToRemove));
  };

  const handleSalesCancelSave = () => {
    setNewSalesType([]);
    form6.resetFields();
    setSalesTypesAddDisable(true);
  };

  const handleSalesSave = async () => {
    const moddedArray = newSalesType?.map((item) => {
      return {
        displayName: item,
        type: "SALES_TYPE",
      };
    });
    try {
      const response = await postRequest(
        userServiceApi.postSalesType(partnerId),
        moddedArray
      );
      if (response) {
        toast.success("New Sales types added");
        setNewSalesType([]);
        getAllSalesTypes();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSalesChecker = async (checked, type) => {
    let editObj = {
      ...type,
      toggle: checked,
    };

    try {
      const response = await putRequest(
        userServiceApi.updateSalesType(partnerId),
        editObj
      );
      if (response) {
        setSalesEditID(null);
        setSalesTypes(response);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSalesEdit = async (value) => {
    let editObj = {
      id: salesEditID,
      displayName: value?.type,
      type: "SALES_TYPE",
    };

    try {
      const response = await putRequest(
        userServiceApi.updateSalesType(partnerId),
        editObj
      );
      if (response) {
        setSalesEditID(null);
        toast.success("Sales type updated successfully");
        setSalesTypes(response);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSalesDelete = async (type) => {
    try {
      const response = await deleteRequest(
        userServiceApi.deleteSalesType(type?.id)
      );
      if (response) {
        getAllSalesTypes();
        toast.success(`${type?.type} deleted successfully`);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="configuration-page">

      <div className="filters-container">
        <div className="partner-heading">
          <div
            className="heading-backBtn"
            onClick={() => {
              navigate("/admin");
              sessionStorage.removeItem("partnerName");
              sessionStorage.removeItem("partnerId");
            }}
          >
            <img src={leftArrow} alt="leftarrow" />
            <p>Configurations {`for ${truncate(partnerName)}` || ""} </p>
          </div>
        </div>
      </div>
      <div className="organisationFormContainer">
        {loading ? (
          <Spin className="data-loader loading-svg" tip="Loading" size="large" />
        ) : (
          <div className="organisation-type">
            <div className="config-heading">Configure organisation type</div>
            <div className="form-component">
              <div className="configureFormRow">
                <div className="configureFormCol">Organisation Type</div>
                <div className="configureFormCol">
                  <div className="configureFieldRow">
                    <div className="configureFieldCol">
                      <Form onFinish={handleAdd} autoComplete="off" form={form1}>
                        <Col className="gutter-row tabContent index-tab" span={16}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <Form.Item
                              name="type"
                              // label="Organisation Type"
                              labelCol={{ span: 7 }}
                              style={{ minWidth: "100%", paddingLeft: "0px" }}
                            >
                              <Input
                                ref={inputRef}
                                className="input-field"
                                placeholder="Enter new organisation type"
                                onChange={() => setOrganisationTypesAddDisable(false)}
                                maxLength={inputFieldCharLimit}
                              />
                            </Form.Item>
                            {organisationTypesAddDisable ? (
                              <Form.Item
                                style={{
                                  marginLeft: "10px",
                                  opacity: "0.5",
                                  cursor: "not-allowed",
                                }}
                              >
                                <Button
                                  className="redBtn add-btn"
                                  style={{ height: "40px" }}
                                >
                                  Add
                                </Button>
                              </Form.Item>
                            ) : (
                              <Form.Item style={{ marginLeft: "10px" }}>
                                <Button
                                  className="redBtn add-btn"
                                  style={{ height: "40px" }}
                                  htmlType="submit"
                                >
                                  Add
                                </Button>
                              </Form.Item>
                            )}
                          </div>
                        </Col>
                      </Form>
                      {newOrganisationType.length > 0 && (
                        <>
                          <div className="new-items">
                            {newOrganisationType?.map((newItem, index) => (
                              <div className="tag" key={newItem}>
                                <Tag
                                  className="tags-component"
                                  closable={true}
                                  onClose={() => handleRemove(newItem)}
                                >
                                  <span
                                    className="ellipsis-tag-content"
                                    title={newItem}
                                  >
                                    {newItem}
                                  </span>
                                </Tag>
                              </div>
                            ))}
                          </div>
                          <div className="btn-container">
                            <Button
                              className="clear-btn"
                              onClick={handlecancelSave}
                            >
                              Cancel
                            </Button>
                            <Button
                              className="redBtn SaveBtn"
                              style={{ marginLeft: "10px" }}
                              onClick={handleSave}
                            >
                              Save
                            </Button>
                          </div>
                          <Divider />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="configureFieldRow">
                    <div className="configureFieldCol">
                      <div className="display">
                        {organisationTypes && organisationTypes.length > 0
                          ? organisationTypes?.map((type) => (
                            <div className="type-item">
                              {type.id === editID ? (
                                <>
                                  <Form
                                    onFinish={handleEdit}
                                    className="item-edit-form"
                                    initialValues={{
                                      type: type.displayName,
                                    }}
                                  >
                                    <div className="inputWithBtn">
                                      <div className="inputWithBtnCol">
                                        <Form.Item name="type">
                                          <Input className="edit-input" />
                                        </Form.Item>
                                      </div>
                                      <div className="inputWithBtnCol">
                                        <div className="inputWithBtnBox">
                                          <Form.Item>
                                            <Button
                                              style={{ marginRight: "5px" }}
                                              className="redBtn SaveBtn"
                                              htmlType="submit"
                                            >
                                              Save
                                            </Button>
                                          </Form.Item>
                                          <Form.Item>
                                            <Button
                                              className="clear-btn"
                                              onClick={() => setEditID()}
                                            >
                                              Cancel
                                            </Button>
                                          </Form.Item>
                                        </div>
                                      </div>
                                    </div>


                                  </Form>
                                </>
                              ) : (
                                <>
                                  <div>{type.displayName}</div>
                                  <div className="op-btns">
                                    <div className="remove-btns">
                                      <img
                                        style={{ marginTop: "2px", cursor: "pointer" }}
                                        src={editIcon}
                                        alt="editIcon"
                                        onClick={() => setEditID(type.id)}
                                      />
                                    </div>
                                    <div className="lineVertical"></div>
                                    {type.isUsed ? (
                                      <>
                                        <Tooltip
                                          title={"Organisation type is in use"}
                                        >
                                          <div
                                            className="remove-btns"
                                            style={{
                                              opacity: "0.5",
                                              cursor: `${type?.toggle ? "not-allowed" : "pointer"}`,
                                            }}
                                          >
                                            <img
                                              src={deleteIcon}
                                              alt="deleteIcon"
                                            />
                                          </div>
                                        </Tooltip>
                                        <div className="lineVertical"></div>
                                        <Tooltip
                                          title={"Organisation type is in use"}
                                        >
                                          <Switch
                                            style={{
                                              opacity: "0.5",
                                              cursor: "not-allowed",
                                            }}
                                            disabled
                                            className="orgtype-switch"
                                            defaultChecked={
                                              type.toggle ? true : false
                                            }
                                          />
                                        </Tooltip>
                                      </>
                                    ) : (
                                      <>
                                        <div className="remove-btns">
                                          <img
                                            src={deleteIcon}
                                            alt="deleteIcon"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleDelete(type)}
                                          />
                                        </div>
                                        <div className="lineVertical"></div>
                                        <Switch
                                          className="orgtype-switch"
                                          defaultChecked={
                                            type.toggle ? true : false
                                          }
                                          onChange={(checked) => {
                                            handleChecker(checked, type);
                                          }}
                                        />
                                      </>
                                    )}
                                  </div>
                                </>
                              )}
                            </div>
                          ))
                          : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="horizontalLine"></div>

        {loadingSalesType ? (
          <Spin className="data-loader loading-svg" tip="Loading" size="large" />
        ) : (
          <div className="organisation-type">
            <div className="config-heading">Configure sales type</div>
            <div className="form-component">
              <div className="configureFormRow">
                <div className="configureFormCol">Sales Type</div>
                <div className="configureFormCol">
                  <div className="configureFieldRow">
                    <div className="configureFieldCol">
                      <Form
                        onFinish={handleSalesAdd}
                        autoComplete="off"
                        form={form6}
                      >
                        <Col className="gutter-row tabContent index-tab" span={16}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <Form.Item
                              name="type"
                              labelCol={{ span: 7 }}
                              style={{ minWidth: "100%", paddingLeft: "0px" }}
                            >
                              <Input
                                ref={inputRef}
                                className="input-field"
                                placeholder="Enter new sales type"
                                onChange={() => setSalesTypesAddDisable(false)}
                                maxLength={inputFieldCharLimit}
                              />
                            </Form.Item>
                            {salesTypesAddDisable ? (
                              <Form.Item
                                style={{
                                  marginLeft: "10px",
                                  opacity: "0.5",
                                  cursor: "not-allowed",
                                }}
                              >
                                <Button
                                  className="redBtn add-btn"
                                  style={{ height: "40px" }}
                                >
                                  Add
                                </Button>
                              </Form.Item>
                            ) : (
                              <Form.Item style={{ marginLeft: "10px" }}>
                                <Button
                                  className="redBtn add-btn"
                                  style={{ height: "40px" }}
                                  htmlType="submit"
                                >
                                  Add
                                </Button>
                              </Form.Item>
                            )}
                          </div>
                        </Col>
                      </Form>
                      {newSalesType?.length > 0 && (
                        <>
                          <div className="new-items">
                            {newSalesType?.map((newItem, index) => (
                              <div className="tag" key={newItem}>
                                <Tag
                                  className="tags-component"
                                  closable={true}
                                  onClose={() => handleSalesRemove(newItem)}
                                >
                                  <span
                                    className="ellipsis-tag-content"
                                    title={newItem}
                                  >
                                    {newItem}
                                  </span>
                                </Tag>
                              </div>
                            ))}
                          </div>
                          <div className="btn-container">
                            <Button
                              className="clear-btn"
                              onClick={handleSalesCancelSave}
                            >
                              Cancel
                            </Button>
                            <Button
                              className="redBtn SaveBtn"
                              style={{ marginLeft: "10px" }}
                              onClick={handleSalesSave}
                            >
                              Save
                            </Button>
                          </div>
                          <Divider />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="configureFieldRow">
                    <div className="configureFieldCol">
                      <div className="display">
                        {salesTypes && salesTypes?.length > 0
                          ? salesTypes?.map((type) => (
                            <div className="type-item">
                              {type?.id === salesEditID ? (
                                <>
                                  <Form
                                    onFinish={handleSalesEdit}
                                    className="item-edit-form"
                                    initialValues={{
                                      type: type?.displayName,
                                    }}
                                  >
                                    <div className="inputWithBtn">
                                      <div className="inputWithBtnCol">
                                        <Form.Item name="type">
                                          <Input className="edit-input" />
                                        </Form.Item>
                                      </div>
                                      <div className="inputWithBtnCol">
                                        <div className="inputWithBtnBox">
                                          <Form.Item>
                                            <Button
                                              style={{ marginRight: "5px" }}
                                              className="redBtn SaveBtn"
                                              htmlType="submit"
                                            >
                                              Save
                                            </Button>
                                          </Form.Item>
                                          <Form.Item>
                                            <Button
                                              className="clear-btn"
                                              onClick={() => setSalesEditID(null)}
                                            >
                                              Cancel
                                            </Button>
                                          </Form.Item>
                                        </div>
                                      </div>
                                    </div>
                                  </Form>
                                </>
                              ) : (
                                <>
                                  <div>{type?.displayName}</div>
                                  <div className="op-btns">
                                    <div className="remove-btns">
                                      <img
                                        style={{ marginTop: "2px", cursor: "pointer" }}
                                        src={editIcon}
                                        alt="editIcon"
                                        onClick={() => setSalesEditID(type?.id)}
                                      />
                                    </div>
                                    <div className="lineVertical"></div>
                                    {type?.isUsed ? (
                                      <>
                                        <Tooltip title={"Sales type is in use"}>
                                          <div
                                            className="remove-btns"
                                            style={{
                                              opacity: "0.5",
                                              cursor: "not-allowed",
                                            }}
                                          >
                                            <img
                                              src={deleteIcon}
                                              alt="deleteIcon"
                                            />
                                          </div>
                                        </Tooltip>
                                        <div className="lineVertical"></div>
                                        <Tooltip title={"Sales type is in use"}>
                                          <Switch
                                            style={{
                                              opacity: "0.5",
                                              cursor: "not-allowed",
                                            }}
                                            disabled
                                            className="orgtype-switch"
                                            defaultChecked={
                                              type.toggle ? true : false
                                            }
                                          />
                                        </Tooltip>
                                      </>
                                    ) : (
                                      <>
                                        <div className="remove-btns">
                                          <img
                                            src={deleteIcon}
                                            alt="deleteIcon"
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              handleSalesDelete(type)
                                            }
                                          />
                                        </div>
                                        <div className="lineVertical"></div>
                                        <Switch
                                          className="orgtype-switch"
                                          defaultChecked={
                                            type.toggle ? true : false
                                          }
                                          onChange={(checked) => {
                                            handleSalesChecker(checked, type);
                                          }}
                                        />
                                      </>
                                    )}
                                  </div>
                                </>
                              )}
                            </div>
                          ))
                          : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Row
                className="rowBody h-25"
                gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
              >
              </Row>
            </div>
          </div>
        )}
        <div className="horizontalLine"></div>

        {loadingPartnerType ? (
          <Spin className="data-loader loading-svg" tip="Loading" size="large" />
        ) : (
          <div className="organisation-type">
            <div className="config-heading">Configure partner type</div>
            <div className="form-component">
              <div className="configureFormRow">
                <div className="configureFormCol">Partner Type</div>
                <div className="configureFormCol">
                  <div className="configureFieldRow">
                    <div className="configureFieldCol">
                      <Form
                        onFinish={handlePartnerAdd}
                        autoComplete="off"
                        form={form2}
                      >
                        <Col className="gutter-row tabContent index-tab" span={16}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <Form.Item
                              name="type"
                              // label="Partner Type"
                              labelCol={{ span: 7 }}
                              style={{ minWidth: "100%", paddingLeft: "0px" }}
                            >
                              <Input
                                ref={inputRef}
                                className="input-field"
                                placeholder="Enter new partner type"
                                onChange={() => setPartnerTypesAddDisable(false)}
                                maxLength={inputFieldCharLimit}
                              />
                            </Form.Item>
                            {partnerTypesAddDisable ? (
                              <Form.Item
                                style={{
                                  marginLeft: "10px",
                                  opacity: "0.5",
                                  cursor: "not-allowed",
                                }}
                              >
                                <Button
                                  className="redBtn add-btn"
                                  style={{ height: "40px" }}
                                >
                                  Add
                                </Button>
                              </Form.Item>
                            ) : (
                              <Form.Item style={{ marginLeft: "10px" }}>
                                <Button
                                  className="redBtn add-btn"
                                  style={{ height: "40px" }}
                                  htmlType="submit"
                                >
                                  Add
                                </Button>
                              </Form.Item>
                            )}
                          </div>
                        </Col>
                      </Form>
                      {newPartnerType.length > 0 && (
                        <>
                          <div className="new-items">
                            {newPartnerType?.map((newItem, index) => (
                              <div className="tag" key={newItem}>
                                <Tag
                                  className="tags-component"
                                  closable={true}
                                  onClose={() => handlePartnerRemove(newItem)}
                                >
                                  <span
                                    className="ellipsis-tag-content"
                                    title={newItem}
                                  >
                                    {newItem}
                                  </span>
                                </Tag>
                              </div>
                            ))}
                          </div>
                          <div className="btn-container">
                            <Button
                              className="clear-btn"
                              onClick={handlePartnercancelSave}
                            >
                              Cancel
                            </Button>
                            <Button
                              className="redBtn SaveBtn"
                              style={{ marginLeft: "10px" }}
                              onClick={handlePartnerSave}
                            >
                              Save
                            </Button>
                          </div>
                          <Divider />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="configureFieldRow">
                    <div className="configureFieldCol">
                      <div className="display">
                        {partnerTypes && partnerTypes.length > 0
                          ? partnerTypes?.map((type) => (
                            <div className="type-item">
                              {type.id === partnerEditID ? (
                                <>
                                  <Form
                                    onFinish={handlePartnerEdit}
                                    className="item-edit-form"
                                    initialValues={{
                                      type: type.displayName,
                                    }}
                                  >
                                    <div className="inputWithBtn">
                                      <div className="inputWithBtnCol">
                                        <Form.Item name="type">
                                          <Input className="edit-input" />
                                        </Form.Item>
                                      </div>
                                      <div className="inputWithBtnCol">
                                        <div className="inputWithBtnBox">


                                          <Form.Item>
                                            <Button
                                              style={{ marginRight: "5px" }}
                                              className="redBtn SaveBtn"
                                              htmlType="submit"
                                            >
                                              Save
                                            </Button>
                                          </Form.Item>
                                          <Form.Item>
                                            <Button
                                              className="clear-btn"
                                              onClick={() => setPartnerEditID()}
                                            >
                                              Cancel
                                            </Button>
                                          </Form.Item>
                                        </div>
                                      </div>
                                    </div>
                                  </Form>
                                </>
                              ) : (
                                <>
                                  <div>{type.displayName}</div>
                                  <div className="op-btns">
                                    <div className="remove-btns">
                                      <img
                                        style={{ marginTop: "2px", cursor: "pointer" }}
                                        src={editIcon}
                                        alt="editIcon"
                                        onClick={() => setPartnerEditID(type.id)}
                                      />
                                    </div>
                                    <div className="lineVertical"></div>
                                    {type.isUsed ? (
                                      <>
                                        <Tooltip title={"Partner type is in use"}>
                                          <div
                                            className="remove-btns"
                                            style={{
                                              opacity: "0.5",
                                              cursor: "not-allowed",
                                            }}
                                          >
                                            <img
                                              src={deleteIcon}
                                              alt="deleteIcon"
                                            />
                                          </div>
                                        </Tooltip>
                                        <div className="lineVertical"></div>
                                        <Tooltip title={"Partner type is in use"}>
                                          <Switch
                                            style={{
                                              opacity: "0.5",
                                              cursor: "not-allowed",
                                            }}
                                            disabled
                                            className="orgtype-switch"
                                            defaultChecked={
                                              type.toggle ? true : false
                                            }
                                          />
                                        </Tooltip>
                                      </>
                                    ) : (
                                      <>
                                        <div className="remove-btns">
                                          <img
                                            src={deleteIcon}
                                            alt="deleteIcon"
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              handlePartnerDelete(type)
                                            }
                                          />
                                        </div>
                                        <div className="lineVertical"></div>
                                        <Switch
                                          className="orgtype-switch"
                                          defaultChecked={
                                            type.toggle ? true : false
                                          }
                                          onChange={(checked) => {
                                            handlePartnerChecker(checked, type);
                                          }}
                                        />
                                      </>
                                    )}
                                  </div>
                                </>
                              )}
                            </div>
                          ))
                          : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Row
                className="rowBody h-25"
                gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
              >
              </Row>
            </div>
          </div>
        )}

        <div className="horizontalLine"></div>
        <div className="sector-subsector">
          <div className="config-heading">Configure categories and sub-categories</div>
          <div className="form-component">

            <div className="configureFormRow">
              <div className="configureFormCol">Categories Type</div>
              <div className="configureFormCol">
                <div className="configureFieldRow">
                  <div className="configureFieldCol">
                    <Form form={form3} style={{ width: "100%" }}>
                      <div className="ms-edit-main-sector">
                        <Form.Item
                          labelCol={{ span: 6 }}
                          name="sector"
                        // label="Categories"
                        >
                          <div className="select-div">
                            <Select
                              value={selectedSector}
                              onChange={(e) => handleSectorSelectChange(e)}
                              placeholder="view and add Categories"
                              optionRender={(option) => (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <span>{option?.data?.label}</span>

                                  <DeleteOutlined
                                    style={{ color: "gray" }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      deleteSector(option?.data);
                                    }}
                                  />
                                </div>
                              )}
                              dropdownRender={(menu) => (
                                <>
                                  {menu}
                                  <Divider
                                    style={{
                                      margin: "8px 0",
                                    }}
                                  />
                                  <Space
                                    style={{
                                      padding: "0 8px 4px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "10px",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Input
                                        placeholder="Please enter Categories"
                                        value={customName}
                                        onChange={onNameChange}
                                      />
                                      <Button
                                        type="text"
                                        icon={<PlusOutlined />}
                                        onClick={addItem}
                                      >
                                        Add Categories
                                      </Button>

                                      <Button
                                        type="text"
                                        disabled={sectors?.length === 0}
                                        icon={<DeleteOutlined />}
                                        onClick={deleteAllSectors}
                                      >
                                        Delete All Categories
                                      </Button>
                                    </div>
                                  </Space>
                                </>
                              )}
                              options={sectors?.map((item) => {
                                return {
                                  label: item.name,
                                  value: item.id || item.name,
                                  status: item?.status,
                                };
                              })}
                            ></Select>
                            {/* {selectedSector ? (
                              <img
                                src={deleteIcon}
                                alt="deleteIcon"
                                style={{ marginLeft: "5px" }}
                                onClick={deleteSector}
                              />
                            ) : null} */}
                          </div>
                        </Form.Item>
                        <Form.Item
                          labelCol={{ span: 6 }}
                          name="subSector"
                        // label="Sub categories"
                        >
                          {sectorSelectedFlag ? (
                            <div className="select-div">
                              <Select
                                value={selectedSubSector}
                                onChange={(e) => handleSubSectorSelectChange(e)}
                                placeholder="view and add sub-categories"
                                optionRender={(option) => (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span>{option?.data?.label}</span>

                                    <DeleteOutlined
                                      style={{ color: "gray" }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleDeleteSubSectorItem(option?.data);
                                      }}
                                    />
                                  </div>
                                )}
                                dropdownRender={(menu) => (
                                  <>
                                    {menu}
                                    <Divider
                                      style={{
                                        margin: "8px 0",
                                      }}
                                    />
                                    <Space
                                      style={{
                                        padding: "0 8px 4px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "10px",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Input
                                          placeholder="Please enter Sub categories"
                                          value={customNameSubSector}
                                          onChange={onNameChangeSubSector}
                                        />
                                        <Button
                                          type="text"
                                          icon={<PlusOutlined />}
                                          onClick={addItemSubSector}
                                        >
                                          Add Sub categories
                                        </Button>

                                        <Button
                                          type="text"
                                          disabled={subsectors?.length === 0}
                                          icon={<DeleteOutlined />}
                                          onClick={deleteAllSubSectors}
                                        >
                                          Delete All Sub-categories
                                        </Button>
                                      </div>
                                    </Space>
                                  </>
                                )}
                                options={subsectors?.map((item) => ({
                                  label: item?.name,
                                  value: item?.id,
                                  status: item?.status
                                }))}
                              ></Select>
                              {/* {selectedSubSector ? (
                                <img
                                  src={deleteIcon}
                                  alt="deleteIcon"
                                  style={{ marginLeft: "5px" }}
                                  onClick={deleteSectorSubSector}
                                />
                              ) : null} */}
                            </div>
                          ) : (
                            <Select
                              disabled
                              value={selectedSubSector}
                              onChange={(e) => handleSubSectorSelectChange(e)}
                              placeholder="view and add Sub categories"
                              dropdownRender={(menu) => (
                                <>
                                  {menu}
                                  <Divider
                                    style={{
                                      margin: "8px 0",
                                    }}
                                  />
                                  <Space
                                    style={{
                                      padding: "0 8px 4px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                      }}
                                    >
                                      <Input
                                        placeholder="Please enter Categories"
                                        value={customNameSubSector}
                                        onChange={onNameChangeSubSector}
                                      />
                                      <Button
                                        type="text"
                                        icon={<PlusOutlined />}
                                        onClick={addItemSubSector}
                                      >
                                        Add Sub categories
                                      </Button>
                                    </div>
                                  </Space>
                                </>
                              )}
                              options={subsectors?.map((item) => ({
                                label: item.name,
                                value: item.id,
                                status: item?.status,
                              }))}
                            ></Select>
                          )}
                        </Form.Item>
                      </div>
                    </Form>
                  </div>
                </div>
                <div className="configureFieldRow">
                  <div className="configureFieldCol">
                    <div className="form-btn-container">
                      <Button
                        onClick={closeSectorModal}
                        className="clear-btn"
                        style={{ marginRight: "10px" }}
                      >
                        Cancel{" "}
                      </Button>
                      {saveDisabled ? (
                        <Button
                          className="saveBtn redBtn"
                          style={{ opacity: "0.5", cursor: "not-allowed" }}
                        >
                          Submit{" "}
                        </Button>
                      ) : (
                        <Button className="saveBtn redBtn" onClick={postsectorSubsector}>
                          Submit{" "}
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div
            className="dividing-line"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Divider
              className="sector-divider"
              style={{
                borderTop: "2px solid #A5A5A5",
                minWidth: "40%",
                width: "40%",
              }}
            />
            <p>Or</p>
            <Divider
              className="sector-divider"
              style={{
                borderTop: "2px solid #A5A5A5",
                minWidth: "40%",
                width: "40%",
              }}
            />
          </div>

          <BulkUploadBlock
            title="Bulk upload categories and sub-categories"
            templateEnum="SECTOR_SUB_SECTOR"
            downloadFileName="sector_sub_sector_template.xlsx"
            getUploadProps={getUploadProps}
            downloadExcelTemplate={downloadExcelTemplate}
          />
        </div>

        <div className="horizontalLine"></div>
        <div className="upload-powered-by-logo">
          <div className="config-heading">Upload powered by Logo</div>
          <div className="form-component">
            <div className="configureFormRow">
              <div className="configureFormCol">Logo</div>
              <div className="configureFormCol">
                <div className="configureFieldRow">
                  <div className="configureFieldCol">
                    <Form autoComplete="off" form={form5}>
                      <Form.Item
                        colon={false}
                        name="poweredLogo"
                        className="experienceImg uploadedImage"
                        labelCol={{ span: 5 }}
                      >
                        <div className="d-flex">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "16px"
                            }}
                          >
                            {partnerDetailsData?.poweredByLogo ? (
                              getFile ? (
                                <Image
                                  src={getFile ? URL.createObjectURL(getFile) : null}
                                  alt={getFile ? getFile?.name : null}
                                  style={{
                                    maxHeight: "80px",
                                    marginRight: "10px",
                                    marginBottom: "-15px",
                                  }}
                                />
                              ) : (
                                <Image
                                  src={partnerDetailsData?.poweredByLogo}
                                  alt=""
                                  style={{
                                    maxHeight: "80px",
                                    marginRight: "10px",
                                    marginBottom: "-15px",
                                  }}
                                />
                              )
                            ) : image === undefined ? (
                              <Image
                                src={UserIcon}
                                alt=""
                                style={{
                                  maxHeight: "80px",
                                  marginRight: "10px",
                                  marginBottom: "-15px",
                                }}
                              />
                            ) : (
                              <Image
                                src={getFile ? URL.createObjectURL(getFile) : null}
                                alt={getFile ? getFile?.name : null}
                                style={{
                                  maxHeight: "80px",
                                  marginRight: "10px",
                                  marginBottom: "-15px",
                                }}
                              />
                            )}

                            <Tooltip title={"Upload image with size lesser than 2.5MB"}>
                              <label
                                name="file"
                                className="fileUploadBtn redBtn"
                                style={{ display: "flex", alignItems: "center", padding: "2px 12px" }}
                              >
                                Upload Image
                                <input
                                  type="file"
                                  accept="image/*"
                                  style={{ display: "none" }}
                                  onChange={changeHandler}
                                />
                              </label>
                            </Tooltip>
                          </div>
                        </div>
                      </Form.Item>
                    </Form>
                  </div>
                </div>
                <div className="configureFieldRow">
                  <div className="configureFieldCol">
                    <div className="form-btn-container">
                      <Button
                        onClick={() => {
                          form5.resetFields();
                        }}
                        type="button"
                        className="clear-btn"
                        style={{ marginRight: "10px" }}
                      >
                        Cancel{" "}
                      </Button>

                      <Button
                        className="saveBtn redBtn"
                        onClick={onFinishPoweredByLogo}
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="horizontalLine"></div>
        <BulkUploadBlock
          title="Bulk upload accurate category and accurate sub-category"
          templateEnum="ACCURATE_SECTOR_SUB_SECTOR"
          downloadFileName="Accurate_Template.xlsx"
          getUploadProps={getUploadProps}
          downloadExcelTemplate={downloadExcelTemplate}
        />
        <div className="horizontalLine"></div>
        <BulkUploadBlock
          title="Bulk upload directories"
          templateEnum="PARTNER_DIRECTORIES"
          downloadFileName="PartnerDirectories.xlsx"
          getUploadProps={getUploadProps}
          downloadExcelTemplate={downloadExcelTemplate}
        />
        <div className="horizontalLine"></div>
        <div className="restore-time">
          <div className="config-heading">Configure restore time</div>
          <div className="form-component">
            <div className="configureFormRow">
              <div className="configureFormCol">Time to restore organisation</div>
              <div className="configureFormCol">
                <div className="configureFieldRow">
                  <div className="configureFieldCol">
                    <Form
                      onFinish={onFinishRestoreConfig}
                      autoComplete="off"
                      form={form}
                    >
                      <Form.Item
                        rules={[
                          {
                            required: true,
                            message: "Please input the number of days.",
                          },
                          {
                            type: "number",
                            message: "Please input a valid number.",
                          },
                          { validator: validateNumber },
                        ]}
                        style={{ minWidth: "100%" }}
                        labelCol={{ span: 7 }}
                        // label="Time to restore organisation"
                        name="deletionThresholdDays"
                        value={restoreTime}
                      >
                        <InputNumber
                          min={1}
                          max={90}
                          style={{
                            width: "100%",
                            height: "40px",
                          }}
                          placeholder="Enter Days to restore organisation"
                          onChange={(e) => {
                            setDisabledSaveTime(false);
                            setRestoreTime(e);
                          }}
                        />
                      </Form.Item>
                    </Form>
                  </div>
                </div>
                <div className="configureFieldRow">
                  <div className="configureFieldCol">
                    <div className="form-btn-container">
                      <Button
                        onClick={() => {
                          setDisabledSaveTime(true);
                          form.resetFields();
                        }}
                        type="button"
                        className="clear-btn"
                        style={{ marginRight: "10px" }}
                      >
                        Cancel{" "}
                      </Button>
                      {disableSaveTime ? (
                        <Button
                          className="saveBtn redBtn"
                          style={{ opacity: "0.5", cursor: "not-allowed" }}
                        >
                          Submit{" "}
                        </Button>
                      ) : (
                        <Button
                          className="saveBtn redBtn"
                          onClick={onFinishRestoreConfig}
                        >
                          Submit
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Row
              className="rowBody h-25"
              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            >
              <Col className="gutter-row tabContent index-tab" span={16}>

              </Col>
            </Row>

          </div>
        </div>

        <div className="horizontalLine"></div>
        <div className="footer-documents">
          <div className="config-heading">Footer Documents Management</div>
          <div className="form-component">
            <FooterDocumentSettings partnerId={partnerId} />
          </div>
        </div>

        <div className="horizontalLine"></div>
        <div className="restore-time">
          <div className="config-heading">Configure Free Trial Period</div>
          <div className="form-component">
            <Form
              onFinish={onFinishSubscriptionTrial}
              autoComplete="off"
              form={form4}
              initialValues={{
                freeTrialPeriod: trialConfig?.freeTrialPeriod,
                extendedTrialPeriod: trialConfig?.extendedTrialPeriod,
                extendedTrialOrganizationLimit:
                  trialConfig?.extendedTrialOrganizationLimit,
                extendedPlanForFreeTrial: trialConfig?.extendedPlanForFreeTrial,
                freePlanAlwaysPlan: trialConfig?.freePlanAlwaysPlan,
                isFreePlanAlways: normalizeFreePlanAlways(
                  trialConfig?.isFreePlanAlways
                ),
              }}
            >
              <div className="configureFormRow">
                <div className="configureFormCol">Select plan type</div>

                <div className="configureFormCol">
                  <Form.Item
                    name="extendedPlanForFreeTrial"
                    dependencies={[
                      "extendedTrialOrganizationLimit",
                      "extendedPlanForFreeTrial",
                      "isFreePlanAlways",
                    ]}
                    rules={[
                      {
                        required: requiresExtendedFreeTrialFields,
                        message: "Please select a plan type.",
                      },
                    ]}
                    style={{ minWidth: "100%" }}
                  >
                    <Radio.Group
                      // disabled={isLaunchOrgZero || isFreeForeverPlan}
                      disabled={isFreeForeverPlan}

                      onChange={(e) => {
                        setDisableFreeTrialSave(false);
                        const planValue = e.target.value;
                        setTrialConfig((prev) => ({
                          ...prev,
                          extendedPlanForFreeTrial: planValue,
                        }));
                      }}
                    >
                      <Radio value="STARTER">Starter</Radio>
                      <Radio value="ESSENTIALS">Essential</Radio>
                      <Radio value="ESSENTIALS_PLUS">Essential Plus</Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>
              </div>

              <div className="configureFormRow">
                <div className="configureFormCol">Number of launch Organisations</div>
                <div className="configureFormCol">
                  <Form.Item
                    dependencies={["extendedPlanForFreeTrial", "isFreePlanAlways"]}
                    rules={[
                      {
                        required: !isFreeForeverPlan,
                        message: "Please input the number of days.",
                      },
                      {
                        type: "number",
                        message: "Please input a valid number.",
                      },
                      {
                        validator: (_, value) => {
                          if (!isFreeForeverPlan && value < 0) {
                            return Promise.reject(
                              new Error("Negative values are not allowed.")
                            );
                          }
                          return Promise.resolve();
                        }
                      }
                    ]}
                    style={{ minWidth: "100%" }}
                    labelCol={{ span: 7 }}
                    name="extendedTrialOrganizationLimit"
                  >
                    <InputNumber
                      min={0}
                      // disabled={isFreeForeverPlan}
                      {...integerInputProps}
                      style={{
                        width: "100%",
                        height: "40px",
                      }}
                      placeholder="Enter number of launch organizations"
                      onChange={(e) => {
                        setDisableFreeTrialSave(false);
                        if (e === 0) {
                          form4.setFieldsValue({
                            extendedPlanForFreeTrial: undefined,
                            extendedTrialPeriod: null,
                            freeTrialPeriod: null,
                          });
                          setTrialConfig((prev) => ({
                            ...prev,
                            extendedTrialOrganizationLimit: 0,
                            extendedPlanForFreeTrial: null,
                            extendedTrialPeriod: null,
                            freeTrialPeriod: null,
                          }));
                          return;
                        }
                        setTrialConfig((prev) => ({
                          ...prev,
                          extendedTrialOrganizationLimit: e,
                        }));
                      }}
                    />
                  </Form.Item>
                </div>
              </div>


              <div className="configureFormRow">
                <div className="configureFormCol">Trial Period (Days)</div>
                <div className="configureFormCol">
                  <Form.Item
                    dependencies={[
                      "extendedTrialOrganizationLimit",
                      "extendedPlanForFreeTrial",
                      "isFreePlanAlways",
                    ]}
                    rules={freeTrialDayFieldRules(requiresExtendedFreeTrialFields)}
                    style={{ minWidth: "100%" }}
                    labelCol={{ span: 7 }}
                    name="extendedTrialPeriod"
                  >
                    <InputNumber
                      min={0}
                      // disabled={areTrialDetailFieldsDisabled}
                      {...integerInputProps}
                      style={{
                        width: "100%",
                        height: "40px",
                      }}
                      placeholder="Enter days to subscription trial"
                      onChange={(e) => {
                        setDisableFreeTrialSave(false);
                        setTrialConfig((prev) => ({
                          ...prev,
                          extendedTrialPeriod: e,
                        }));
                      }}
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="configureFormRow">
                <div className="configureFormCol">All other Organisations Trial Period (Days)</div>
                <div className="configureFormCol">
                  <Form.Item
                    dependencies={[
                      "extendedTrialOrganizationLimit",
                      "extendedPlanForFreeTrial",
                      "isFreePlanAlways",
                    ]}
                    rules={freeTrialDayFieldRules(requiresExtendedFreeTrialFields)}
                    style={{ minWidth: "100%" }}
                    labelCol={{ span: 7 }}
                    name="freeTrialPeriod"
                  >
                    <InputNumber
                      min={0}
                      // disabled={areTrialDetailFieldsDisabled}
                      // disabled={isFreeForeverPlan}

                      {...integerInputProps}
                      style={{
                        width: "100%",
                        height: "40px",
                      }}
                      placeholder="Enter days to subscription trial"
                      onChange={(e) => {
                        setDisableFreeTrialSave(false);
                        setTrialConfig((prev) => ({
                          ...prev,
                          freeTrialPeriod: e,
                        }));
                      }}
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="configureFormRow">
                <div className="configureFormCol">Free forever</div>
                <div className="configureFormCol">
                  <Form.Item
                    name="isFreePlanAlways"
                    valuePropName="checked"
                    getValueProps={(value) => ({
                      checked: value === true,
                    })}
                    style={{ minWidth: "100%" }}
                  >
                    <Checkbox
                      onChange={(e) => {
                        setDisableFreeTrialSave(false);
                        const checked = e.target.checked;
                        if (checked) {
                          form4.setFieldsValue({
                            isFreePlanAlways: true,
                            extendedTrialOrganizationLimit: null,
                            extendedTrialPeriod: null,
                            freeTrialPeriod: null,
                          });
                          setTrialConfig((prev) => ({
                            ...prev,
                            isFreePlanAlways: true,
                            extendedTrialOrganizationLimit: null,
                            extendedTrialPeriod: null,
                            freeTrialPeriod: null,
                          }));
                          return;
                        }
                        form4.setFieldsValue({
                          isFreePlanAlways: false,
                          freePlanAlwaysPlan: undefined,
                        });
                        setTrialConfig((prev) => ({
                          ...prev,
                          isFreePlanAlways: false,
                          freePlanAlwaysPlan: null,
                        }));
                      }}
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="configureFormRow">
                <div className="configureFormCol">Select Free plan type</div>
                <div className="configureFormCol">
                  <Form.Item
                    name="freePlanAlwaysPlan"
                    dependencies={["isFreePlanAlways"]}
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (getFieldValue("isFreePlanAlways") !== true) {
                            return Promise.resolve();
                          }
                          if (
                            value == null ||
                            String(value).trim() === ""
                          ) {
                            return Promise.reject(
                              new Error("Please select a  free plan type.")
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                    style={{ minWidth: "100%" }}
                  >
                    <Radio.Group
                      disabled={!isFreeForeverPlan}
                      onChange={(e) => {
                        setDisableFreeTrialSave(false);
                        const planValue = e.target.value;
                        setTrialConfig((prev) => ({
                          ...prev,
                          freePlanAlwaysPlan: planValue,
                        }));
                      }}
                    >
                      <Radio value="STARTER">Starter</Radio>
                      <Radio value="ESSENTIALS">Essential</Radio>
                      <Radio value="ESSENTIALS_PLUS">Essential Plus</Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>
              </div>

              <div className="configureFormRow" style={{ justifyContent: "flex-end" }}>
                <div className="configureFieldRow">
                  <div className="configureFieldCol">
                    <div className="form-btn-container">
                      <Button
                        onClick={handleFreeTrialCancel}
                        type="button"
                        className="clear-btn"
                        style={{ marginRight: "10px" }}
                      >
                        Cancel{" "}
                      </Button>
                      <Button
                        onClick={handleFreeTrialClear}
                        type="button"
                        className="clear-btn"
                        style={{ marginRight: "10px" }}
                      >
                        Clear{" "}
                      </Button>
                      {disableFreeTrialSave ? (
                        <Button
                          className="saveBtn redBtn"
                          style={{ opacity: "0.5", cursor: "not-allowed" }}
                        >
                          Submit{" "}
                        </Button>
                      ) : (
                        <Button
                          className="saveBtn redBtn"
                          htmlType="submit"
                        >
                          Submit
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>




        <div className="horizontalLine"></div>
        <div className="footer-documents">
          <div className="form-component">
            <PaymentPlanConfiguration
              partnerId={partnerId}
              countryId={partnerDetailsData?.countryId}
              disabled={isFreeForeverPlan}
            />
          </div>
        </div>



      </div>

    </div>
  );
}
